import module from 'recursoshumanos/module.js'

const schema = {
  capturados: 'number',
  encontrados: 'number',
}

export class RecursoshumanosPagosSuaService {
  constructor ($http, $window) {
    this.$http = $http
    this.$window = $window
  }

  post (idEmpresa, registroPatronal, periodicidad, data, periodo, mes) {
    return this.$http.post('/api/recursos_humanos/sua/pagos', data, {
      params: {
        id_empresa: idEmpresa,
        registro_patronal: registroPatronal,
        periodicidad,
        periodo,
        mes,
      },
    })
  }
}

module.service('RecursoshumanosPagosSuaService', RecursoshumanosPagosSuaService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/PagosSua.js